const StlPrintingMessages = {
  message1: 'Dirección:',
  message2: 'Programar Recolección',
  label1: 'Fecha de Recolección',
  label2: 'Hora de Recolección'
}

export default StlPrintingMessages
